import { useEffect } from "react";
import { motion } from "framer-motion";
import { Shield } from "lucide-react";
import { useI18n } from "@/hooks/use-i18n";
import { HeaderBar } from "@/components/HeaderBar";
import { Footer } from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";

export default function Privacy() {
  const { t, tArray, dir, lang, setLang } = useI18n();

  useEffect(() => {
    document.title = `${t("privacy.title")} - Aurelian Private Care`;
  }, [t, lang]);

  const bullets = tArray("privacy.bullets");

  return (
    <div className="flex flex-col min-h-screen" dir={dir}>
      <HeaderBar lang={lang} onChangeLang={setLang} dir={dir} />

      <main className="flex-1 flex items-center justify-center py-20 px-6">
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="w-full max-w-2xl"
        >
          <Card className="bg-card/50 backdrop-blur-xl border-border/30 shadow-lg">
            <CardContent className="pt-10 pb-10 px-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                  <Shield className="w-5 h-5 text-primary" />
                </div>
                <h1
                  className="text-2xl font-serif font-bold text-foreground"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                  data-testid="text-privacy-title"
                >
                  {t("privacy.title")}
                </h1>
              </div>

              <ul className="space-y-3">
                {bullets.map((bullet, i) => (
                  <motion.li
                    key={i}
                    className={`flex items-start gap-3 text-sm text-muted-foreground leading-relaxed ${dir === "rtl" ? "flex-row-reverse text-right" : ""}`}
                    initial={{ opacity: 0, x: dir === "rtl" ? 12 : -12 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.35, delay: 0.1 + i * 0.06 }}
                    data-testid={`text-privacy-bullet-${i}`}
                  >
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-primary/40 shrink-0" />
                    <span>{bullet}</span>
                  </motion.li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </motion.div>
      </main>

      <Footer t={t} dir={dir} />
    </div>
  );
}
